import { useAtomValue } from 'jotai';

import { DescriptionBlock } from '../../legacy';

import { jobPositionApiDataAtom } from '../job-position.atoms';

export const JobDescriptionCard = () => {
  const jobPositionApiData = useAtomValue(jobPositionApiDataAtom);
  return jobPositionApiData?.job_description ? (
    <>
      <DescriptionBlock subTitle={jobPositionApiData?.job_title} jobContractDesc={jobPositionApiData.job_description} />
      <hr className="text-gray-300" />
    </>
  ) : null;
};
